import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const USER_PROFILE_QUERY_KEY = ["userProfile"] as const;
export const FRIENDS_QUERY_KEY = ["friends"] as const;
export const SEARCH_FRIENDS_QUERY_KEY = ["searchFriends"] as const;

export type UpdateUserProfileData = InferRequestType<
  typeof client.users.me.$patch
>["json"];

export type UpdateAvatarResponse = InferResponseType<
  typeof client.users.me.avatar.$patch,
  200
>;

export type UpdateProfileResponse = InferResponseType<
  typeof client.users.me.$patch,
  200
>;

export type UserProfileResponse = InferResponseType<
  typeof client.users.profile.$get,
  200
>;

// Friend request types
export type SendFriendRequestData = InferRequestType<
  typeof client.friends.$post
>["json"];

export type SendFriendRequestResponse = InferResponseType<
  typeof client.friends.$post,
  200
>;

// Handle friend request types
export type HandleFriendRequestData = InferRequestType<
  typeof client.friends.requests.$post
>["json"];

export type HandleFriendRequestResponse = InferResponseType<
  typeof client.friends.requests.$post,
  200
>;

// Get friends and requests types
export type GetFriendsResponse = InferResponseType<
  typeof client.friends.$get,
  200
>;

// Search friends types
export type SearchFriendsData = InferRequestType<
  typeof client.friends.search.$post
>["json"];

export type SearchFriendsResponse = InferResponseType<
  typeof client.friends.search.$post,
  200
>;

// Remove friend types
export type RemoveFriendData = InferRequestType<
  typeof client.friends.$delete
>["json"];

export type RemoveFriendResponse = InferResponseType<
  typeof client.friends.$delete,
  200
>;
